export default __webpack_public_path__ + "static/media/DS_LOGO.f3d4cc51.png";